import React, { useEffect, useState } from 'react';

import DefaultArtisanMenu from './ArtisanMenu';
import { callBackFunction } from '../../Utils/ListFunctions';
import collections from '../../../constants/collections';
import ListLogic from '../ListLogic';
import api from '../../../api';

const functionType = [
  {
    type: 'categories',
    callback: callBackFunction.categories,
  },
  {
    type: 'companyName',
    callback: callBackFunction.companyName,
  },
  {
    type: 'artisanStatus',
    callback: callBackFunction.AStatus,
  },
  {
    type: 'substatus',
    callback: callBackFunction.ASubStatus,
  },
  {
    type: 'level',
    callback: callBackFunction.ALevel,
  },
  {
    type: '_dossier',
    callback: callBackFunction.dossier,
  },
  {
    type: 'remuneration',
    callback: callBackFunction.remuneration,
  },
  {
    type: 'debriefUser',
    callback: callBackFunction.debriefUser,
  },
  {
    type: 'equipeAreasArtisan',
    callback: callBackFunction.equipeAreasArtisan,
  },
  {
    type: 'source',
    callback: callBackFunction.source,
  },
];

const ArtisanList = (props) => {
  const {

    name = collections.artisans.capitalize(),
    listen = collections.artisans,
    handlerFilterByColumns,
    filteredByColumn = true,

    actions,
    menu,
    sort,
    filterName,
    count,
    filter: filterProps,
    list
  } = props;

  const [filter, setFilter] = useState(filterProps);
  const [display] = useState(count || 10);


  useEffect(() => {
    setFilter(filterProps);
  }, [filterProps]);

  if (filterName !== 'default' && Object.keys(filter).length === 0) {
    return null;
  }
  return (
    <React.Fragment>
      <ListLogic
        {...list}
        functionType={functionType}
        project={[]}
        name={name}
        actions={actions}
        collection={listen}
        filteredByColumn={filteredByColumn}
        handlerFilterByColumns={handlerFilterByColumns}
        listen={listen}
        filter={filter}
        count={display}
        sort={sort}
        menu={menu || DefaultArtisanMenu}
        customReq={api.all(`${collections.artisans}/details`).getAll}
      />
    </React.Fragment>
  );
};

export default ArtisanList;
